// Landing-page route wrapper. Shows the landing page, and on the first tap hands over
// to the normal funnel (<App/>) in place: no reload, so attribution captured at boot and
// the session id carry straight through.
//
// A tapped body area is written to the questionnaire's own local state (the same place
// an answer to question one goes) and the funnel opens on the next unanswered question.
// It never goes into a URL or an analytics event.
import { useEffect, useState } from 'react';
import App from '../App';
import { track } from '../lib/analytics';
import { OnlinePT } from './OnlinePT';
import { seedBodyArea } from '../lib/prefill';

export const LANDING_VARIANT = 'lp-online-pt';

export function LandingApp() {
  const [started, setStarted] = useState(false);

  // The tab title matches the ad; the funnel's own title comes back once it starts.
  useEffect(() => {
    if (started) return;
    const funnelTitle = document.title;
    document.title = 'Physical therapy at home · Expy Health';
    return () => {
      document.title = funnelTitle;
    };
  }, [started]);

  if (started) return <App />;

  return (
    <OnlinePT
      onStart={(area) => {
        if (area) seedBodyArea(area);
        track('cta_click', { variant: LANDING_VARIANT });
        // Put the funnel on its canonical URL so a reload resumes the questionnaire
        // instead of showing the landing page again.
        window.history.replaceState(null, '', '/');
        window.scrollTo({ top: 0, behavior: 'auto' });
        setStarted(true);
      }}
    />
  );
}
